"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Where the time goes: one stacked bar, and the table under it.
 *
 * Width is the only thing the bar encodes. Every segment is the same color on
 * purpose — alternating shades would let neighbors be told apart, but a
 * reader has no way to know that, and a bar in two shades looks like it is
 * encoding something.
 *
 * The bar and the table share one hover state, which is what makes the bar
 * legible: a segment carries no label, and a row names a stretch the eye
 * cannot find in the bar.
 */
const styles = exports.styles = {
  phaseBar: {
    display: "x78zum5",
    width: "xh8yej3",
    height: "xb8l8e1",
    borderRadius: "x1pq0x4f",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    overflow: "xb3r6kr",
    overflowX: null,
    overflowY: null,
    marginBottom: "xhbfen4",
    $$css: true
  },
  phaseSegment: {
    backgroundColor: "x1c1r1s3",
    minWidth: "x9041oi",
    cursor: "xsid9ct",
    borderRightWidth: "xyy74w7",
    borderInlineStartWidth: null,
    borderInlineEndWidth: null,
    borderRightStyle: "x32b0ac",
    borderInlineStartStyle: null,
    borderInlineEndStyle: null,
    borderRightColor: "xjq5cyi",
    borderInlineStartColor: null,
    borderInlineEndColor: null,
    transitionProperty: "x1clg7gw",
    transitionDuration: "xbb3pvg",
    transitionTimingFunction: "x9lcvmn",
    $$css: true
  },
  phaseSegmentActive: {
    backgroundColor: "x134gdg2",
    $$css: true
  },
  phaseRow: {
    cursor: "xt0e3qv",
    transitionProperty: "x15406qy",
    transitionDuration: "xbb3pvg",
    transitionTimingFunction: "x9lcvmn",
    $$css: true
  },
  phaseRowActive: {
    backgroundColor: "xeolxmk",
    $$css: true
  }
};